import React from 'react';

const SearchField = (props) => {
	return (
		<div className="field has-addons">
			<div className="control is-expanded">
				<input type="search" onChange={props.onChangeInput} className="input" value={props.value} placeholder={props.placeholder}/>
			</div>
			<div className="control">
				<a className="button is-info">Cerca</a>
			</div>
		</div>
	)
}

export default SearchField;


// WEBPACK FOOTER //
// ./src/components/search-field.jsx